module.exports = __webpack_public_path__ + "img/4ec8b61.jpg";